import React from 'react'
import { Container } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'
import { setToggleTrue } from '../redux/slice/changeState';
import { useDispatch } from 'react-redux';

const Ready = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 700px)' });
  const dispatch = useDispatch();
  return (
    <div className='ready-section text-left h-100vh' id='price' >
        <Container>
          {
            isMobile ?
            <div className='pt-4 ps-4'>
            <h2 className='pt-4'>Ready to Make</h2>
            <h2 className='mb-3'><span>IRA Miracle</span> Your Home?</h2>
            <h6>Don’t miss out on the opportunity</h6>
            <h6>to own one of Kollur’s best 3 BHK</h6>
            <h6 className='mb-3'>apartments.</h6>
            </div>
            :
            <div className='pt-2 ps-2'>
            <h2>Ready to Make <span>IRA Miracle</span> Your Home?</h2>
            <h6>Don’t miss out on the opportunity to own one of Kollur’s best 3 BHK apartments.</h6>
            </div>
          }
        
        <div className='d-flex justify-content-left button-section ps-3'>
            <button className='common-btn primary-background text-white ' onClick={() => dispatch(setToggleTrue())}>Schedule a Site Visit</button>
            <a className='common-btn text-white text-decoration-none '  href="https://wa.api-whatsapp.in/bglS5n"
              target="_blank"
              rel="noreferrer">Chat on Whatsapp</a>

            
        </div>
        </Container>
    </div>
  )
}

export default Ready
